import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type SecurityEvents =
  | 'TABLE_NAME_CELL_CLICK'
  | 'EDIT_DIALOG_CLOSE_WITHOUT_CHANGES'
  | 'EDIT_DIALOG_CLOSE'
  | 'CREATE'
  | 'UPDATE'
  | 'DUPLICATE'
  | 'ACTIVATE'
  | 'DEACTIVATE'
  | 'DELETE';

export const security: Record<SecurityEvents, MixpanelEvent> = {
  TABLE_NAME_CELL_CLICK: {
    eventDescription: 'Security Policy Table Name Cell Click',
    eventKey: 'security-policy-table-name-cell-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  },
  EDIT_DIALOG_CLOSE_WITHOUT_CHANGES: {
    eventDescription: 'Security Policy Close Edit Dialog Without Changes',
    eventKey: 'security-policy-close-edit-dialog-without-changes',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  EDIT_DIALOG_CLOSE: {
    eventDescription: 'Security Policy Edit Dialog Close',
    eventKey: 'security-policy-edit-dialog-close',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  CREATE: {
    eventDescription: 'Security Policy Create Policy',
    eventKey: 'security-policy-create-policy',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  UPDATE: {
    eventDescription: 'Security Policy Update Policy',
    eventKey: 'security-policy-update-policy',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  DUPLICATE: {
    eventDescription: 'Security Policy Duplicate Policy',
    eventKey: 'security-policy-duplicate-policy',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  ACTIVATE: {
    eventDescription: 'Security Policy Activate Policy',
    eventKey: 'security-policy-activate-policy',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  DEACTIVATE: {
    eventDescription: 'Security Policy Deactivate Policy',
    eventKey: 'security-policy-deactivate-policy',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  DELETE: {
    eventDescription: 'Security Policy Delete Policy',
    eventKey: 'security-policy-delete-policy',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  }
} as const;
